require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-code-201-foundations-of-software-development.json") })
        }
      }, "path---courses-code-201-foundations-of-software-development");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-code-201-foundations-of-software-development!./.cache/json/courses-code-201-foundations-of-software-development.json
// module id = 1156
// module chunks = 231608221292675